import { makeStyles } from 'tss-react/mui'
import { nunito_sans } from '@styles/fonts'
import { lato } from '@styles/fonts'

const useStyles = makeStyles()((theme) => ({
  root: {},
  img: {
    height: 'auto',
    width: '100%',
  },
  imgCard: {
    height: 'auto',
    width: '100%',
    borderRadius: '20px',
    cursor: 'pointer',
  },
  date: {
    fontFamily: nunito_sans.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '12px',
    lineHeight: '27px',
    textTransform: 'uppercase',
    color: '#818181',
    textAlign: 'start',
    marginTop: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(2),
    },
  },
  title: {
    fontFamily: nunito_sans.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 800,
    fontSize: '32px',
    lineHeight: '29px',
    textTransform: 'uppercase',
    color: '#000000',
    textAlign: 'start',
    marginTop: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      fontSize: '24px',
      marginTop: theme.spacing(2),
    },
  },
  header: {
    fontFamily: nunito_sans.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 800,
    fontSize: '72px',
    lineHeight: '29px',
    textTransform: 'uppercase',
    color: '#000000',
    textAlign: 'center',
    margin: theme.spacing(22, 0, 0),
    [theme.breakpoints.down('md')]: {
      fontSize: '46px',
      margin: theme.spacing(14, 0),
    },
  },
  partners: {
    fontFamily: nunito_sans.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '14px',
    textTransform: 'uppercase',
    color: '#000000',
    textAlign: 'start',
    opacity: '0.7',
  },
  name: {
    fontFamily: nunito_sans.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '16px',
    textTransform: 'uppercase',
    letterSpacing: '0.02em',
    color: '#000000',
    textAlign: 'start',
  },
  avatar: {
    width: '69px',
    height: '69px',
    [theme.breakpoints.down('md')]: {
      width: '55px',
      height: '55px',
    },
  },
  brandInfo: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(5),
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(4),
    },
  },
  linkTitle: {
    display: 'flex',
    justifyContent: 'space-between',
  },

  desc: {
    fontStyle: 'normal',
    fontWeight: '400',
    fontFamily: lato.style.fontFamily,
    fontSize: '25px',
    lineHeight: '24px',
    color: '#000000',
    textAlign: 'center',
    opacity: '0.7',

    margin: theme.spacing(8, 0, 16),
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      textAlign: 'center',
      fontSize: '18px',
      lineHeight: '24px',
    },
  },
}))

export default useStyles
